module.exports = __webpack_public_path__ + "static/media/ic_comment_enabled.be2d6ceb.svg";